/* Akyilia campaign calendar — the one place that decides seasonal wording across the storefront.
   Only messaging and subtle accents change. Prices, Buy 1 + Get 1 FREE and checkout never change here.
   Preview any campaign with ?campaign=<id> (e.g. ?campaign=black-friday). */
(() => {
  const OFFER = 'Buy 1, Get 1 FREE';

  // Seasons cover the whole year; events sit on top and win while they run.
  const SEASONS = [
    { id: 'winter', from: [1, 1], to: [2, 28], name: 'Winter', label: 'WINTER GLOW EVENT', eyebrow: 'The winter glow edit', icon: '❄️', accent: '#9fb8d6' },
    { id: 'spring', from: [3, 1], to: [5, 31], name: 'Spring', label: 'SPRING REFRESH EVENT', eyebrow: 'The spring refresh edit', icon: '🌸', accent: '#f2a7c3' },
    { id: 'summer', from: [6, 1], to: [8, 31], name: 'Summer', label: 'SUMMER GLOW EVENT', eyebrow: 'The summer glow edit', icon: '☀️', accent: '#f4c26b' },
    { id: 'fall', from: [9, 1], to: [11, 30], name: 'Fall', label: 'FALL GLOW EVENT', eyebrow: 'The fall glow edit', icon: '🍂', accent: '#d9925f' },
    { id: 'holiday-season', from: [12, 1], to: [12, 31], name: 'Holiday', label: 'HOLIDAY GLOW EVENT', eyebrow: 'The holiday glow edit', icon: '✨', accent: '#c9a45c' }
  ];

  // nth weekday of a month (weekday 0 = Sunday)
  const nthWeekday = (y, m, weekday, n) => {
    const d = new Date(y, m - 1, 1);
    d.setDate(1 + ((weekday - d.getDay() + 7) % 7) + (n - 1) * 7);
    return d;
  };
  const add = (d, days) => { const x = new Date(d); x.setDate(x.getDate() + days); return x; };
  const day = (y, m, d) => new Date(y, m - 1, d);

  // Higher priority wins when events overlap.
  const eventsFor = y => {
    const thanksgiving = nthWeekday(y, 11, 4, 4);
    const blackFriday = add(thanksgiving, 1);
    const cyberMonday = add(blackFriday, 3);
    const mothersDay = nthWeekday(y, 5, 0, 2);
    return [
      { id: 'new-year', start: day(y, 1, 1), end: day(y, 1, 7), priority: 50, name: 'New Year', label: 'NEW YEAR GLOW EVENT', eyebrow: 'New year, new night routine', icon: '🥂', accent: '#c9a45c' },
      { id: 'valentines', start: day(y, 2, 1), end: day(y, 2, 14), priority: 70, name: "Valentine's", label: "VALENTINE'S GLOW EVENT", eyebrow: 'The Valentine’s glow edit', icon: '💗', accent: '#e0597f' },
      { id: 'mothers-day', start: add(mothersDay, -14), end: mothersDay, priority: 70, name: "Mother's Day", label: "MOTHER'S DAY EVENT", eyebrow: 'A night routine she’ll love', icon: '💐', accent: '#f2a7c3' },
      { id: 'halloween', start: day(y, 10, 20), end: day(y, 10, 31), priority: 60, name: 'Halloween', label: 'HALLOWEEN GLOW EVENT', eyebrow: 'Peel off something scary-good', icon: '🎃', accent: '#e08a3c' },
      { id: 'black-friday', start: add(thanksgiving, -3), end: add(blackFriday, 2), priority: 100, name: 'Black Friday', label: 'BLACK FRIDAY EVENT', eyebrow: 'The Black Friday glow edit', icon: '🖤', accent: '#1e0f14' },
      { id: 'cyber-monday', start: cyberMonday, end: add(cyberMonday, 1), priority: 100, name: 'Cyber Monday', label: 'CYBER MONDAY EVENT', eyebrow: 'The Cyber Monday glow edit', icon: '💻', accent: '#6b7cff' },
      { id: 'holiday', start: day(y, 12, 1), end: day(y, 12, 24), priority: 80, name: 'Holiday', label: 'HOLIDAY GIFTING EVENT', eyebrow: 'The holiday gifting edit', icon: '🎁', accent: '#c9a45c' },
      { id: 'new-year-eve', start: day(y, 12, 26), end: day(y, 12, 31), priority: 50, name: 'New Year', label: 'NEW YEAR GLOW EVENT', eyebrow: 'New year, new night routine', icon: '🥂', accent: '#c9a45c' }
    ];
  };

  const endOfDay = d => { const x = new Date(d); x.setHours(23, 59, 59, 999); return x; };

  function pick(now) {
    const y = now.getFullYear();
    const active = eventsFor(y).filter(e => now >= e.start && now <= endOfDay(e.end)).sort((a, b) => b.priority - a.priority);
    if (active.length) return { ...active[0], ends: endOfDay(active[0].end) };
    const md = (now.getMonth() + 1) * 100 + now.getDate();
    const s = SEASONS.find(s => md >= s.from[0] * 100 + s.from[1] && md <= s.to[0] * 100 + s.to[1]) || SEASONS[0];
    return { ...s, ends: null };
  }

  function byId(id, now) {
    const all = [...eventsFor(now.getFullYear()), ...SEASONS];
    const c = all.find(c => c.id === id);
    return c ? { ...c, ends: c.end ? endOfDay(c.end) : null } : null;
  }

  let forced = null;
  try { forced = new URLSearchParams(location.search).get('campaign'); } catch {}
  const now = new Date();
  const c = (forced && byId(forced, now)) || pick(now);

  // "Ends <date>" only when the event really ends within 3 days; never invented urgency.
  const endsSoon = c.ends && (c.ends - now) / 864e5 <= 3;
  const endsText = endsSoon ? ' Ends ' + c.ends.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + '.' : '';

  const copy = {
    announce: `${c.label} · ${OFFER}`,
    eyebrow: c.eyebrow,
    headline: `${c.name} Event: ${OFFER}`,
    note: `${c.name} Event · ${OFFER} · 30-Day Guarantee`,
    ends: endsText.trim()
  };

  window.AK_CAMPAIGN = { ...c, copy };
  const root = document.documentElement;
  root.dataset.campaign = c.id;
  root.style.setProperty('--campaign-accent', c.accent);

  const apply = () => {
    document.querySelectorAll('[data-camp]').forEach(el => {
      const key = el.dataset.camp;
      if (key === 'announce') el.textContent = `${c.icon} ${copy.announce}`;
      else if (key === 'headline') el.textContent = copy.headline + (endsText ? ' ·' + endsText.replace(/\.$/, '') : '');
      else if (copy[key] !== undefined) el.textContent = copy[key];
    });
  };
  // Countdown: only for campaigns with a real end date; hidden otherwise (no midnight resets).
  const pad = n => String(n).padStart(2, '0');
  const renderTimers = () => {
    const left = c.ends ? c.ends - Date.now() : 0;
    document.querySelectorAll('.timer').forEach(t => {
      if (!c.ends || left <= 0) { t.style.display = 'none'; t.setAttribute('aria-hidden', 'true'); return; }
      t.style.display = ''; t.removeAttribute('aria-hidden');
      t.setAttribute('aria-label', `${c.name} event ends in`);
      const d = Math.floor(left / 864e5), h = Math.floor(left % 864e5 / 36e5), m = Math.floor(left % 36e5 / 6e4), s = Math.floor(left % 6e4 / 1e3);
      const vals = d > 0 ? [[d, 'DAYS'], [h, 'HRS'], [m, 'MIN']] : [[h, 'HRS'], [m, 'MIN'], [s, 'SEC']];
      t.querySelectorAll(':scope > div').forEach((box, i) => {
        if (!vals[i]) return;
        const b = box.querySelector('b'), sm = box.querySelector('small');
        if (b) b.textContent = pad(vals[i][0]);
        if (sm) sm.textContent = vals[i][1];
      });
    });
  };
  const start = () => { apply(); renderTimers(); setInterval(renderTimers, 1000); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
